"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

var ScrollWrapper = _styledComponents.default.div.withConfig({
  displayName: "UISection__ScrollWrapper",
  componentId: "hm68fz-0"
})(["height:", ";&&{", ";}& >:last-child{margin-bottom:0;}"], function (props) {
  return (0, _Styles.toPx)(props.height);
}, function (props) {
  return props.flush && "margin-bottom: 0";
});

var UISection = (0, _react.forwardRef)(function (props, ref) {
  var className = props.className,
      use = props.use,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "use"]);
  return _react.default.createElement(ScrollWrapper, Object.assign({}, rest, {
    className: (0, _classnames.default)("is--module namespaced-hack-section", className, use === 'island' && 'is--island'),
    ref: ref
  }));
});
UISection.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool.isRequired,
  height: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  use: _propTypes.default.oneOf(['default', 'island']).isRequired
};
UISection.defaultProps = {
  flush: false,
  overhang: false,
  overhangDirection: 'horizontal',
  use: 'default'
};
UISection.displayName = 'UISection';
var _default = UISection;
exports.default = _default;
module.exports = exports.default;